// This handles the deprecated interface and converts it to a type that can be discriminated
export const toDiscriminatedProps = ({ cacheQuery, ...rest }) => ({
    type: 'query',
    node: cacheQuery,
    ...rest,
});
